import { useEffect } from "react";
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { useLeaflet } from "react-leaflet";
//const mcg = L.markerClusterGroup();

const CircleMarker = ({ data }) => {
  
  const { map } = useLeaflet();
  useEffect(() => {
    if (data && data.length > 0) {
      data.forEach((item) => {
        const target_location = JSON.parse(item['target_location']);
        const unitConvert = (target_location && target_location.unit && target_location.unit === 'miles')?1609.34:1000;
        L.circle([target_location.latitude, target_location.longitude], { radius: unitConvert*parseInt(target_location.radius) }).addTo(map);
      })
    }
  }, [data, map]);
  return null;
};
export default CircleMarker;